module.exports = __webpack_public_path__ + "img/attention-3.34582ccc.jpg";